import { faCheck } from "@jewlr/pro-regular-svg-icons/faCheck"
import { Box, Flex, FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { getStep, progressLabels } from "./components"

const Container = styled(Box).attrs({
  mb: { _: "80px", tablet: "72px" },
  mt: { _: 3, tablet: 5 },
})``

const ProgressBar = styled(Flex)`
  justify-content: space-between;
`

const StepLabel = styled(Box)`
  font-size: 14px;
  font-weight: 700;
  left: 50%;
  letter-spacing: -0.03em;
  position: absolute;
  text-align: center;
  top: 100%;
  transform: translateX(-50%);
  ${(props) => props.theme.mediaQueries.tablet`
    left: auto;
    transform: none;
    width: 100%;
  `}
`

const ProgressStep = styled(Flex)`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: relative;
  ${(props) => props.theme.mediaQueries.tablet`
    flex: 1;
  `}

  &:before,
  &:after {
    border-bottom: 4px solid
      ${(props) =>
        props.completed
          ? props.theme.colors.greenDarker
          : props.theme.colors.grey[30]};
    content: "";
    left: 100%;
    position: absolute;
    top: 12px;
    width: 20vw;
    z-index: 2;
    ${(props) => props.theme.mediaQueries.tablet`
      left: 50%;
      width: 100%;
    `}
  }

  &:first-child::before,
  &:last-child::after {
    content: none;
  }

  ${(props) => props.theme.mediaQueries.tablet`
    &:before {
      left: -50%;
    }
  `}

  ${(props) => props.theme.mediaQueries.mobileOnly`
    &:before {
      content: none;
    }

    &:first-child {
      align-items: flex-start;

      ${StepLabel} {
        left: 0;
        text-align: left;
        transform: none;
      }
    }

    &:last-child {
      align-items: flex-end;

      ${StepLabel} {
        left: auto;
        text-align: right;
        transform: none;
      }
    }
  `}
`

const StepIcon = styled(Flex)`
  align-items: center;
  background: ${(props) =>
    props.completed
      ? props.theme.colors.greenDarker
      : props.theme.colors.grey[30]};
  border-radius: 50%;
  height: 28px;
  justify-content: center;
  margin-bottom: 10px;
  position: relative;
  width: 28px;
  z-index: 3;
`

const Progress = ({ customerState }) => {
  const step = getStep(customerState)

  return (
    <Container>
      <ProgressBar>
        {progressLabels.map(({ name, width }, index) => {
          const completed = index <= step

          return (
            <ProgressStep completed={completed} key={name}>
              <StepIcon completed={completed}>
                <FontAwesomeIcon color="white" fontSize="16px" icon={faCheck} />
              </StepIcon>
              <StepLabel width={width}>{name}</StepLabel>
            </ProgressStep>
          )
        })}
      </ProgressBar>
    </Container>
  )
}

Progress.propTypes = {
  customerState: PropTypes.string,
}

export default Progress
